// src/components/ItemList.tsx
import React, { memo, type MouseEvent } from 'react';
import { List, ListItem, ListItemText } from '@mui/material';
import type { ItemDesc } from '../types';

type Props = {
  items: ItemDesc[];
  onSelected?: (item: ItemDesc) => void;
};

export const ItemList = memo(function ItemList({ items, onSelected }: Props) {
  if (!items?.length) return null;

  const handleClick = (e: MouseEvent<HTMLDivElement>) => {
    const name = (e.currentTarget as HTMLDivElement).dataset.name;
    if (!name || !onSelected) return;
    const hit = items.find(i => i.name === name);
    if (hit) onSelected(hit);
  };

  return (
    <div className="list-wrapper">
      <List className="list" dense>
        {items.map((item) => (
          <ListItem
            key={item.name}
            button
            data-name={item.name}
            onClick={handleClick}
            className="list-item"
          >
            <ListItemText primary={item.name} />
          </ListItem>
        ))}
      </List>
    </div>
  );
});
